import { Component,OnInit, Inject, LOCALE_ID } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';
import { Router } from '@angular/router';
import { GlobalService } from '../services/global.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import {Constant} from '../../constant'
import * as moment from 'moment';

@Component({
  selector: 'app-instabuser',
  templateUrl: './instabuser.component.html',
  styleUrls: ['./instabuser.component.css']
})
export class InstabuserComponent implements OnInit  {
  public registerForm: FormGroup;
  public autopolicyno: any;
  public autodob: any;
  public originalPremiumAmt: 0;
  public submitted = false;
  public isValidAppno = false;
  public isValidAge = false;
  public isValidYear = false;
  public isstatus: any = '';
  public age: number;
  public finalDate;
  public Amount: any;
  public isError = false;
  public isErrorNewForm = false;
  public errorMessage: any;
  modalRef: BsModalRef;
  public userDatanewCustomer: any
  public userDataexistingCustomer: any
  public bsConfig;
  public bsConfig1;
  public temp: any;
  public uniqueid:any;
  templateRef: any;
  isExistingCustomer: boolean = false;
  public isInstab:boolean=false;
  constructor(private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder, @Inject(LOCALE_ID)
    private locale: string,
    private router: Router,
    private service: GlobalService,
    private localStorageService: LocalStorageService,
    private toster: ToastrService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {

   this.loadJss();
   this.isInstab=this.localStorageService.get('isInstab');
   this.uniqueid=this.localStorageService.get('uniqueid');
  //  console.log("inside ngoninit instab user")
  if(this.isInstab == false){
    // console.log("HIIII",this.isInstab)
    //window.location.replace("http://10.3.4.38/CustomerPortal/OpenLink/index.html/#/")
  // window.location.replace("https://bajajuat.bajajallianz.com/CustomerPortal/OpenLink/index.html#/"); // pre-prod
  //  window.location.replace("https://balicuat.bajajallianz.com/CustomerPortal/OpenLink/index.html#/"); // UAT 6
  // window.location.replace("https://balicuat2.bajajallianzlife.com/CustomerPortal/OpenLink/index.html#/");
 window.location.replace(Constant.BaseUrl + "CustomerPortal/OpenLink/index.html#/"); // Production
  }
    this.registerForm = this.formBuilder.group({
      appno: ['', ],
      dob: ['', Validators.required],
      Amount: ['', [Validators.required]],
      frequency: ['', [Validators.required]],
      ischecked:['', [Validators.required]]
    });

    this.userDatanewCustomer = {
      applicationNo: '',
      dateOfBirth: "",
      premiumAmount: '',
      frequency: '',
      ischecked:''
    };
    this.userDatanewCustomer.applicationNo= this.uniqueid;
    this.userDataexistingCustomer = {
      policyNumber: '',
      dateOfBirth: "",
    };
    this.bsConfig = {
      containerClass: 'theme-green',
      isAnimated: true,
      dateInputFormat: 'dd-MM-yyyy'
    };
    this.bsConfig1 = {
      containerClass: 'theme-green',
      isAnimated: true,
      dateInputFormat: 'dd/MM/yyyy'
    };

    this.spinner.show();
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide();
    }, 1000);
  } // end ngonInit

  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }

  loadJss() {

    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    }
  }
  closethePopup() {
    // console.log("inside close popup")
    this.isErrorNewForm = false;
    this.isError = false;
  }

  submitNewCustomerData(template) {
    if (this.isValidAppno) {
      this.toster.error("Please fill the required fields!")
      return;
    }
    this.isErrorNewForm = false;
    this.localStorageService.set('Status', this.isstatus)
    // const date1 = formatDate(this.userDatanewCustomer.dateOfBirth, this.bsConfig.dateInputFormat, this.locale);
    // const date1 =  moment(this.userDatanewCustomer.dateOfBirth).format('DD/MM/YYYY');
    const date1 =  moment(this.userDatanewCustomer.dateOfBirth, 'DD-MM-YYYY').format('DD-MM-YYYY')
    this.userDatanewCustomer.dateOfBirth = date1;
    if (this.userDatanewCustomer.frequency.toString() === 'Monthly') {
      this.Amount = this.userDatanewCustomer.premiumAmount;
      //this.Amount = (this.Amount * 1.1);
      this.Amount = (this.Amount * 1.50);
    } else if (this.userDatanewCustomer.frequency.toString() === 'Quarterly') {
      this.Amount = this.userDatanewCustomer.premiumAmount;
      //this.Amount = (this.Amount * 1.1);
      this.Amount = (this.Amount * 1.50);
    } else if (this.userDatanewCustomer.frequency.toString() === 'Half-Yearly') {
      this.Amount = this.userDatanewCustomer.premiumAmount;
     // this.Amount = (this.Amount * 1.1);
      this.Amount = (this.Amount * 1.50);
    } else if (this.userDatanewCustomer.frequency.toString() === 'Yearly') {
      this.Amount = this.userDatanewCustomer.premiumAmount;
    //  this.Amount = (this.Amount * 1.10);
      this.Amount = (this.Amount * 1.50);
    }

    let url = Constant.BaseUrl + Constant.setNewCustomerData;
    let reqObj = {
      "p_unique_id":this.userDatanewCustomer.applicationNo,
      "p_application_no":this.userDatanewCustomer.applicationNo,
      "p_dob": this.userDatanewCustomer.dateOfBirth,
      "p_prem_amount": this.Amount.toFixed(2),
      "p_frequency_value": this.userDatanewCustomer.frequency,
      "p_module": 'OPEN_LINK_NEW',
      "p_is_unique_code":'YES'
    }
    this.spinner.show();

    this.service.PostService(url, reqObj).subscribe(response => {
      if (response.p_error_code === 'SUCCESS') {
        this.spinner.hide();
        this.isInstab=false;
        this.localStorageService.set("isInstab",this.isInstab);
        this.localStorageService.set("userdata", response.p_data);
        this.localStorageService.set("originalpremiumamt", this.userDatanewCustomer.premiumAmount);
        this.localStorageService.set("mandateVal", this.Amount.toFixed(2));
        this.router.navigate(['/Customer']);
        // console.log("data is-->", response.p_data)
      }
      else {
        this.spinner.hide();
        this.modalRef = this.modalService.show(template, { class: 'modal-sm addcompmodal' });
        this.isErrorNewForm = true;
        this.errorMessage = response.p_message;
        this.userDataexistingCustomer.policyNumber = '';
        this.userDataexistingCustomer.dateOfBirth = '';
        this.router.navigate(['/dashboard']);
      }
    }, (error) => {
      this.spinner.hide();
    })
  }

  onValueChange(value: Date): void {   //age calculation
    var date = new Date(this.userDatanewCustomer.dateOfBirth);
    this.userDatanewCustomer.dateOfBirth = value;
    if (this.userDatanewCustomer.dateOfBirth) {
      var timeDiff = Math.abs(Date.now() - new Date(this.userDatanewCustomer.dateOfBirth).getTime());
      this.age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
      if (this.age < 18) {
        this.isValidAge = true;
      }
      else {
        this.isValidAge = false;
      }
    }
  }
  onSelect() {
      this.isstatus = 'newCustomer';
  }

  onDateChange(newDate: Date) {
    // console.log(newDate);
  }
  acceptOnlyNo(event: any) {
    const pattern = /^[0-9]*$/;
    if (!pattern.test(event.target.value)) {
      event.target.value = event.target.value.replace(/[^0-9]/g, "");
    }
  }
  public CalculateAge(): void {
    var date = new Date(this.userDatanewCustomer.dateOfBirth);
    var year = date.getFullYear();
    var currentyear = (new Date()).getFullYear();
    if (this.userDatanewCustomer.dateOfBirth) {

      var timeDiff = Math.abs(Date.now() - new Date(this.userDatanewCustomer.dateOfBirth).getTime());
      this.age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
      // console.log(this.age);

      if (this.age < 18) {
        this.isValidAge = true;
      }
      else {
        this.isValidAge = false;
      }
    }
  }
}

